import React from 'react';
import Pie from "@/components/common/pie/Pie";
import {STANDARD_CATEGORIES_BY_KEY} from "@/lib/constants.mjs";

const colorVariations = {
	'#5b388f': 'bg-[#5b388f]',
	primary: 'bg-primary',
	secondary: 'bg-secondary',
	danger: 'bg-danger',
	success: 'bg-success',
	darkness: 'bg-darkness',
	geography: 'bg-geography',
	entertainment: 'bg-entertainment',
	history: 'bg-history',
	arts: 'bg-arts',
	science: 'bg-science',
	sports: 'bg-sports',
	"Staff Picks": 'bg-staff',
	"Trending Playlists": "bg-trending",
	"Infinite Pursuit":"bg-primary"
}

const CategoryHeader = ({gameMode, category, pieMask=0x00, monotone=false, color='#5b388f', opaque=false}) => {
	const background = opaque ? colorVariations[color] :  colorVariations[gameMode] ? colorVariations[gameMode] : 'bg-black bg-opacity-30';
	const isLiveMode = gameMode === "Trivial Pursuit Live!";
	return (
		<div className={`relative w-full ${isLiveMode ? 'text-center' : ''}`}>
			<h1 className={'font-gBold w-full pb-1 md:text-[34px] text-[24px]'}>{gameMode}</h1>
			{ category && 
				<h2 data-testid="question-category" className={`px-2 py-1 w-full ${background} rounded-lg uppercase font-gSemi md:text-[28px] text-[16px]`}>{category}</h2>
			}
			{pieMask >= 0 && !isLiveMode &&
				<div className={'absolute right-2 bottom-0.5 md:w-[100px] md:h-[100px] w-[64px] h-[64px]'}>
					<Pie className={'w-full h-[64px] md:h-[100px] md:w-[100px]'}
							 monotone={monotone}
							 color={color}
							 entertainment={pieMask & STANDARD_CATEGORIES_BY_KEY.entertainment.mask}
							 geography={pieMask & STANDARD_CATEGORIES_BY_KEY.geography.mask}
							 sports={pieMask & STANDARD_CATEGORIES_BY_KEY.sports.mask}
							 science={pieMask & STANDARD_CATEGORIES_BY_KEY.science.mask}
							 history={pieMask & STANDARD_CATEGORIES_BY_KEY.history.mask}
							 arts={pieMask & STANDARD_CATEGORIES_BY_KEY.arts.mask}
					/>
				</div>
			}
		</div>
	);
};

export default CategoryHeader;
